import _ from 'underscore';
import { PerfMarker } from './marker';
import { TAnyFunction, TAnyAsyncFunction } from './types';

const functionWithPerfMarker = function (perfMarker: PerfMarker, func: TAnyFunction, context?: any) {
  if (!_.isFunction(func)) {
    return null;
  }

  const newFunc = function (this: any, ...args: any[]) {
    perfMarker.willInit();

    const result = func.apply(context || this, args);

    perfMarker.done();

    return result;
  };

  return newFunc;
};

const asyncFunctionWithPerfMarker = function (perfMarker: PerfMarker, asyncFunc: TAnyAsyncFunction, context?: any) {
  if (!_.isFunction(asyncFunc)) {
    return null;
  }

  const newAsyncFunc = function (this: any, ...args: any[]) {
    perfMarker.willInit();

    return asyncFunc.apply(context || this, args).then((result) => {
      perfMarker.done();

      return result;
    });
  };

  return newAsyncFunc;
};

export { functionWithPerfMarker, asyncFunctionWithPerfMarker };
